<template>
  <i ref="icon" class="icon" :class="[rotationClass, {flipX, flipY}]">
    <slot></slot>
  </i>
</template>

<script>
export default {
  name: 'BIcon',
  props: {
    rotate: String,
    flipX: Boolean,
    flipY: Boolean
  },
  computed: {
    rotationClass() {
      if(!this.rotate) return '';
      return 'rotate-'+this.rotate;
    }
  },
  mounted() {
    this.$refs.icon.querySelector('svg').setAttribute('viewBox', '0 0 45 45');
  }
}
</script>

<style scoped lang="scss">
  i {
    display: inline-block;
    font-size: inherit;
    transform: translateY(11.22222%);
    transition: transform 0.3s;
    svg {
      width: 1em;
      height: auto;
      display: block;
    }
    *:not([fill=none]) {
      fill: currentColor;
    }
  }
  .rotate {
    &-1x {
      transform: rotate(90deg);
    }
    &-2x {
      transform: rotate(180deg);
    }
    &-3x {
      transform: rotate(-90deg);
    }
  }
  .flipX {
    transform: scaleX(-1);
  }
  .flipY {
    transform: scaleY(-1);
  }
</style>

<docs>
  Ícones
</docs>

